import {useLocation, useNavigate} from "react-router-dom";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import React, {useState} from "react";
import './wines.css'

function ViewWine() {
    const location = useLocation();
    const user = location.state?.user;
    const wine = location.state?.wine;

    const [isCollapsed, setIsCollapsed] = useState(true);
    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />
            <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
                <div className="main-admin-page-inner">
                    <h2>{wine.name}</h2>
                    <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                        <div className="wine-image-container" style={{ flex: 4}}>
                            <img style={{width: '150px'}} src={'https://vinimark.s3.amazonaws.com/web/'+ wine.high_res_image_path} alt="wine-image" />
                        </div>
                        <div style={{flex: 6, textAlign: 'left', padding: '10px'}}>
                            <img style={{height: '200px'}} src={'https://vinimark.s3.amazonaws.com/web/'+ wine.brand_image} alt="wine-image" />
                            <p><span style={{fontWeight: 400}}>Stock Code:</span> {wine.stock_code}</p>
                            <p><span style={{fontWeight: 400}}>Vintage:</span> {wine.year}</p>
                            <p><span style={{fontWeight: 400}}>Price:</span> R{wine.price_case} ( R{wine.price_bottle} per bottle)</p>
                            <p><span style={{fontWeight: 400}}>Range: </span>{wine.brand.name}</p>
                            <p><span style={{fontWeight: 400}}>Cultivar: </span>{wine.cultivator.name}</p>
                            <p><span style={{fontWeight: 400}}>Color: </span>{wine.type.name}</p>
                            <p><span style={{fontWeight: 400}}>Description:<br/> </span>{wine.description}</p>


                            <a
                                href={'https://vinimark.s3.amazonaws.com/web/' + wine.tasting_note_path} target={'_blank'}
                                style={{ color: 'black', textDecoration: 'none', fontWeight: 500 }}
                            >
                                <p style={{fontWeight: 600}}>View Fact Sheet</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default ViewWine;
